import React, { useState } from 'react';
import { Gauge } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { ApprovalsTab } from './overOrdering/ApprovalsTab';
import { ClientsTab } from './overOrdering/ClientsTab';
import { PolicyTab } from './overOrdering/PolicyTab';

/**
 * Over-ordering controls.
 *
 * Guaranteed Returns means the bakery carries the loss on anything a client
 * orders and does not sell. Three surfaces, in order of how often they are
 * needed: the orders waiting on a decision, the clients the rule has caught,
 * and the policy behind both.
 */
const OverOrdering = () => {
  const [tab, setTab] = useState('approvals');

  return (
    <div className="space-y-6" data-testid="over-ordering-page">
      <div className="flex items-start gap-3">
        <div className="p-2 rounded-lg bg-orange-100 mt-0.5">
          <Gauge className="h-5 w-5 text-orange-700" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Over-ordering</h1>
          <p className="text-sm text-gray-600 mt-1 max-w-2xl">
            A ceiling on what a guaranteed-returns client can order — their own best single
            delivery, plus an allowance — and a hold on the orders that pass it.
          </p>
        </div>
      </div>

      <Tabs value={tab} onValueChange={setTab} className="space-y-4">
        <TabsList>
          <TabsTrigger value="approvals" data-testid="tab-approvals">Approvals</TabsTrigger>
          <TabsTrigger value="clients" data-testid="tab-oo-clients">Clients</TabsTrigger>
          <TabsTrigger value="policy" data-testid="tab-oo-policy">Policy</TabsTrigger>
        </TabsList>

        <TabsContent value="approvals">
          <ApprovalsTab active={tab === 'approvals'} />
        </TabsContent>
        <TabsContent value="clients">
          <ClientsTab active={tab === 'clients'} />
        </TabsContent>
        <TabsContent value="policy">
          <PolicyTab active={tab === 'policy'} />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default OverOrdering;
